<audio controls autoplay="autoplay" controlsList="nodownload">
    <source [src]="src" type="audio/mp3" />
    Your browser does not support the audio element.
</audio>
